import {
    ApiResponse,
    RegistrationCheckContentModelApiResponse,
    RegistrationSubmittedIdsResultApiResponse,
    UpdateRegistrationModel,
} from '../../types/__generated__/registration'
import { get, post, put } from '../api/axiosClient'
import { RegistrationPostModel } from '../../types/registration-data'
import { PendingRegistrationDataModelApiResponse } from '../../types/__domain__/registration'

export const fetchQuestions = async (): Promise<RegistrationCheckContentModelApiResponse> => {
    let url = `/api/registration/registration-check`

    const response = await get(url)
    return response.data
}

export const createRegistration = async (
    registrationData: RegistrationPostModel,
): Promise<RegistrationSubmittedIdsResultApiResponse> => {
    let url = `/api/registration/create`

    const body = {
        ...registrationData,
    }

    const response = await put(url, body)
    return response.data
}

export const registrationReview = async ({
    correlationId,
}: RegistrationPostModel): Promise<PendingRegistrationDataModelApiResponse> => {
    let url = `/api/registration/${correlationId}`

    const response = await get(url)
    return response.data
}

export const rejectRegistration = async (correlationId: string): Promise<ApiResponse> => {
    if (!correlationId) return
    let url = `/api/registration/reject/${correlationId}`

    const response = await post(url)
    return response.data
}

export const approveRegistration = async (
    correlationId: string,
    formData?: RegistrationPostModel,
    removeContracts?: boolean,
): Promise<ApiResponse> => {
    if (!correlationId) return
    let url = `/api/registration/approve/${correlationId}`

    let body: UpdateRegistrationModel = {}
    if (formData) {
        body = {
            registrationData: {
                ...formData,
            },
        }
    }
    if (removeContracts) {
        body.removeContracts = true
    }

    const response = await post(url, body)
    return response.data
}

export default fetchQuestions
